import { gql } from '@apollo/client';
import { useMutation } from '@hooks/apollo';

export const CREATE_SIGNED_URL = gql`
  mutation Mutation($input: CreateSignedUrlMutationInput!) {
    createDocumentSignedUrl(input: $input) {
      signedUrl
      clientMutationId
    }
  }
`;

export const useCreateSignedUrlMutation = (options = {}) => useMutation(
  CREATE_SIGNED_URL,
  { ...options },
);
